import { createClient } from "@sanity/client";
import { SANITY_DATASET, SANITY_PROJECT_ID } from "../utils/constants";

const sanityClient = createClient({
  projectId: SANITY_PROJECT_ID,
  dataset: SANITY_DATASET,
  apiVersion: "2026-09-09",
  useCdn: true,
});

export interface SanityEvent {
  _id: string;
  title: string;
  excerpt: string;
  content: string;
  image: string;
  link: string;
}

export const getEvents = async (): Promise<SanityEvent[]> => {
  const query = `
    *[_type in ["event", "post"] && ("events" in categories[]->slug.current || "events" in categories[]->title.current)]
      | order(coalesce(date, _createdAt) desc)[0...3] {
      _id,
      title,
      "excerpt": coalesce(excerpt, pt::text(body), ""),
      "content": coalesce(content, url, ""),
      "image": coalesce(image.asset->url, featuredImage.asset->url, imageUrl, ""),
      "link": coalesce(url, "")
    }
  `;

  return (sanityClient as unknown as {
    fetch<T>(groqQuery: string): Promise<T>;
  }).fetch<SanityEvent[]>(query);
};
